import Vue from 'vue'
import VueGtag from 'vue-gtag'

import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import configService from '@/config.service'

Vue.config.productionTip = false

// Global include all components from the design system
const requireComponent = require.context('aladin-design-system/src/components/', true, /Adn[A-Z]\w+\.vue$/)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = fileName.replace(/^.*\//, '').replace(/\.vue$/, '')
  Vue.component(componentName, componentConfig.default || componentConfig)
})

const { analyticsId } = configService.getConfig()

Vue.use(
  VueGtag,
  {
    config: {
      id: analyticsId
    },
    appName: 'Developers Portal Aladin',
    pageTrackerScreenviewEnabled: true
  },
  router
)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
